// src/data/posterPublications.js

const posterPublications = [
    {
        id: "pub-003",
        title: "Mentalic Net: Development of RAG-based Conversational AI and Evaluation Framework for Mental Health Support: A Holistic and Human-in-the-Loop Approach",
        authors: ["Anandi Dutta", "Shivani Mruthyunjaya", "Jessica Saddington", "Kazi Sifatul Islam", "Grish Gautam" ],
        journalConference: "AI in HealthCare Conference, Ken Kennedy Institute, Rice University",
        publicationDate: "2025-09-24",
        abstract: "Conversational AI for Mental Health Support",
        link: "https://example.com/pub3",
        type: "Poster",
    },
    {
        id: "pub-006",
        title: "A Patient-Centric Approach: Development of Conversational AI for Radiology Reports and Prescription Explainability",
        authors: ["Anandi Dutta", "Shivani Mruthyunjaya"],
        journalConference: "AI in HealthCare Conference, Ken Kennedy Institute, Rice University",
        publicationDate: "2025-09-24",
        abstract: "Development of Conversational AI for Radiology Reports and Prescription Explainability",
        link: "https://example.com/pub1",
        type: "Poster",
    },
    {
        id: "pub-007",
        title: "Development of Conversational AI for Mental Health Support",
        authors: ["Anandi Dutta", "Shivani Mruthyunjaya"],
        journalConference: "Health Scholar Showcase, Translational Health Research Center, Texas State University",
        publicationDate: "2025-04-04",
        abstract: "This poster details the development and preliminary evaluation of a conversational AI system designed to provide accessible and empathetic mental health support.",
        link: "https://example.com/pub-mental-health-ai",
        type: "Poster",
    },
    {
        id: "pub-008",
        title: "Task-specific Evaluation for Biomedical Large Language Models (LLMs) for the HealthCare Industry",
        authors: ["Anandi Dutta"],
        journalConference: "TechConnect World Innovation Conference and Expo",
        publicationDate: "2025-06-09",
        abstract: "This presentation outlines a novel framework for evaluating the performance of biomedical Large Language Models (LLMs) on specific tasks relevant to the healthcare industry, ensuring their accuracy and reliability in clinical applications.",
        link: "https://example.com/pub-biomed-llm",
        type: "Poster",
    },
    {
        id: "pub-009",
        title: "From Prediction to Action: A Hybrid ML-RL Model for Smart Grid Stability Control",
        authors: ["Kazi Sifatul Islam", "Anandi Dutta"],
        journalConference: "Graduate Student Research Conference (GSRC'2025), The Graduate College, Texas State University",
        publicationDate: "2025-05-01",
        abstract: "We propose a hybrid machine learning and reinforcement learning model designed to predict power grid instabilities and enact real-time, optimized control strategies for enhanced grid reliability and efficiency.",
        link: "https://example.com/pub-hybrid-ml-rl",
        type: "Poster",
    },
    {
        id: "pub-010",
        title: "AI-Driven Predictions of In-Hospital Mortality After Orthopedic Surgery",
        authors: ["Li Chih-ying", "Anandi Dutta"],
        journalConference: "AIM-AHEAD Annual Meeting",
        publicationDate: "2025-07-08",
        abstract: "This poster presents an AI-driven predictive model for assessing the risk of in-hospital mortality following orthopedic surgery, aiming to aid clinicians in early intervention and patient management.",
        link: "https://example.com/pub-ortho-mortality",
        type: "Poster",
    },
];

export default posterPublications;
